import React, { useEffect, useState, useCallback, Suspense } from 'react';
import LoaderComponent from '@components/atom/layout/loader';
import { useSelector } from 'react-redux';
import { RootState } from '@reducers/index';
import { QueryHookParam, useQueryDummyHook } from '@utils/hook/useQueryHook';
import { CreateAsoOption } from '@classes/options/chart/aso/aso';
import { PieChartDataModel } from '@models/highChartsModel';
import { ScoreBarType } from '@models/aso/aso';
import { gameProviderTypes } from '@configs/layout';

const AppInfo = React.lazy(() => import('@components/template/layout/appInfo/appInfo'));
const PlayStore = React.lazy(() => import('@components/template/aso/mko/playStore'));
const AppStore = React.lazy(() => import('@components/template/aso/mko/appStore'));

type Props = {};

const Mko = (props: Props) => {
  const { selectedAppInfo } = useSelector((state: RootState) => state.LAYOUT);

  // mko 데이터
  const mkoParams: QueryHookParam = {
    key: ['mkoData', selectedAppInfo?.appId],
    url: '/api/aso/mkoGoogle.json', // 여기서 강제로 바꿔줘야함... mkoApple.json / mkoGoogle.json
    params: { appId: selectedAppInfo?.appId, type: selectedAppInfo?.provider_type },
    method: 'GET',
    enabled: selectedAppInfo !== null,
  };
  const { data: mkoData, isLoading } = useQueryDummyHook(mkoParams);

  return (
    <>
      <div className="app-info">
        <Suspense fallback={<LoaderComponent />}>
          <AppInfo />
        </Suspense>
      </div>
      {selectedAppInfo && mkoData && (
        <Suspense fallback={<LoaderComponent />}>
          {selectedAppInfo.provider_type === gameProviderTypes.AppleAppStore ? (
            <AppStore iconImg={selectedAppInfo.icon} data={mkoData} isLoading={isLoading} />
          ) : (
            <PlayStore iconImg={selectedAppInfo.icon} data={mkoData} isLoading={isLoading} />
          )}
        </Suspense>
      )}
    </>
  );
};

export default Mko;
